export const SET_DANH_SACH_DON_HANG_TRANG_KET_THUC = 'SET_DANH_SACH_DON_HANG_TRANG_KET_THUC'


export const LAY_DANH_SACH_DON_HANG_TRANG_KET_THUC_SAGA = 'LAY_DANH_SACH_DON_HANG_TRANG_KET_THUC_SAGA'

export const CHINH_SUA_TRANG_THAI_DON_HANG_TRANG_KET_THUC_SAGA = 'CHINH_SUA_TRANG_THAI_DON_HANG_TRANG_KET_THUC_SAGA'

